import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function LoadingSpinner() {
  return (
    <output className="spinner" aria-label="Loading">
      <FontAwesomeIcon icon={faSpinner} spin aria-hidden="true" />
    </output>
  );
}

export default LoadingSpinner;